import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

import AuctionVideoStream from '../BiddingConsole/components/AuctionVideoStream/AuctionVideoStream';
import AuctionVideoPageHeaderMeta from './AuctionVideoPageHeaderMeta';

type RouteParams = {
    catalogId: string;
};

const AboutUsPage = () => {
    const { catalogId: catalogIdString } = useParams<RouteParams>();
    const catalogId = Number(catalogIdString);

    useEffect(() => {
        const { style } = document.documentElement;
        style.backgroundColor = 'black';
        return () => {
            style.backgroundColor = '';
        };
    }, []);

    return (
        <div className="bg-black flex h-full items-center justify-center">
            <AuctionVideoPageHeaderMeta catalogId={catalogId} />
            <AuctionVideoStream catalogId={catalogId} />
        </div>
    );
};

export default AboutUsPage;
